import axios from 'axios'
import { cca_config } from '@/config'

export default () => {
    return axios.create({
        baseURL: cca_config.C_URL+cca_config.C_URL_STOCK_API,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',

        }
    })
}
